<template>
  <div class="content" style="position: relative;">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Bookings List</h2>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Bookings List</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

             <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="tableData">
              <el-table-column
                :min-width="200"
                align="left"
                label="User Details"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.user_id.phone_number }}</div>
                      <div>
                        {{
                          props.row.user_id.first_name +
                          " " +
                          props.row.user_id.last_name
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="200"
                align="left"
                label="Booking Date"
              >
                <div slot-scope="props">
                  <div>{{ getBookDateTime(props.row) }}</div>
                </div>
              </el-table-column>
              <el-table-column
                :min-width="150"
                align="center"
                label="Cancelation Date"
              >
                <div slot-scope="props">
                  <div>{{ props.row.canceled_at ? getCancelDateTime(props.row.canceled_at) : "" }}</div>
                </div>
              </el-table-column>
              <el-table-column
              :min-width="130"
                align="center"
                label="type"
              >
                <div slot-scope="props">
                  <div>{{ props.row.type === 'GAME' ? 'CREDIT CARD' : props.row.type.toUpperCase() }}</div>
                </div>
              </el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                label="Event Name"
              >
                <div slot-scope="props">
                  <div>{{ props.row.event_id.event_name }}</div>
                </div>
              </el-table-column>
              <el-table-column
                align="center"
                label="price"
              >
                <div slot-scope="props">
                  <div>{{ props.row.price }}</div>
                  <!-- <div>{{ props.row.type != "Partial" ? props.row.price :  (props.row.partial_card_total - props.row.partial_tax_amount) + " (" + props.row.price + ")"  }}</div> -->
                </div>
              </el-table-column>

              <el-table-column
                :min-width="135"
                align="center"
                label="Booking Status"
              >
                <div slot-scope="props">
                  {{ getCapatilizeStatusText(props.row.booking_status) }}
                  <base-button
                    @click.native="handleEdit(props.$index, props.row)"
                    class="edit btn-link"
                    type="warning"
                    size="sm"
                    icon
                    v-if="props.row.booking_status != 'Booked'"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from }} to {{ to }} of {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <!-- <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div> -->
    </div>

    <modal :show.sync="modals_classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Booking Status</h4>
      <div class="row">
        <div class="col-sm-4"><b>Status</b></div>
        <div class="col-sm-4"><b>Time</b></div>
        <div class="col-sm-4"><b>Date</b></div>
        </div>
      <div
        class="row"
      >
        <div class="col-sm-4">{{ currentOrder.booking_status }}</div>
        <div class="col-sm-4">{{ getTime(currentOrder)  }}</div>
         <div class="col-sm-4">{{ getDate(currentOrder)  }}</div>
      </div>

      <div class="row" style="margin: 40px 0px 20px 0px">
        <div
          class="col-sm-6"
          v-for="action in actions"
          v-bind:key="action.status"
        >
          <base-button
            native-type="submit"
            type="primary"
            class="btn-fill"
            @click="updateStatus(action)"
          >
            {{ action.BTNText }}
          </base-button>
        </div>
      </div>
    </modal>
    <div v-if="loading" class="global-loading-overlay"></div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import users from "./orders";
// import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";
import moment from 'moment';
import debounce from 'lodash/debounce';

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    // queriedData() {
    //   return this.searchQuery ? this.searchedData : this.tableData;
    // },
    from() {
      return this.tableData.length === 0 ? 0 : (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
    },
    to() {
      return this.from + this.tableData.length - 1;
    },
  },
  data() {
    return {
      noDataMessage: false,
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 50, 100],
        total: 0,
      },
      searchQuery: "",
      tableData: [],
      currentOrder: {},
    };
  },
  methods: {
      getBookDate(props){
          return moment(props.row.created_at).format('DD-MM-YYYY');
      },

      getBookDateTime(row) {
        return moment(row.created_at).format('DD-MM-YYYY hh:mm a');
      },
      getTime(props){
          return moment(props.created_at).format('hh:mm');
      },
      getDate(props){
        return moment(props.created_at).format('DD-MM-YYYY');
      },
      getCancelDateTime(canceled_at){
          return moment(canceled_at).format('DD-MM-YYYY hh:mm a');
      },
    getCapatilizeStatusText(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    handleEdit(index, row) {
      this.modals_classic = true;
      this.currentOrder = row;
      console.log(row);
      switch (row.booking_status.toUpperCase()) {
        case "NEW":
          this.actions = [{ Track: "Booked", BTNText: "Confirm" }];
          break;
        case "CONFIRMED":
          this.actions = [
            { Track: "PREPARED", BTNText: "Order Prepared" },
            { Track: "SHIPPED", BTNText: "Order Shipped" },
          ];
          break;
        case "PREPARED":
          this.actions = [
            { Track: "SHIPPED", BTNText: "Order Shipped" },
            { Track: "DELIVERED", BTNText: "Order Delivered" },
          ];
          break;
        case "SHIPPED":
          this.actions = [{ Track: "DELIVERED", BTNText: "Order Delivered" }];
          break;
        default:
          this.actions = [];
      }
    },
    async updateStatus(action) {
      let test = await this.$apiService.postCall(
        `booking/update-bookingstatus/${this.currentOrder._id}`,{
           "booking_status": `${action.Track}`
        }
      );
      this.$apiService.notify("Order updated successfully.");
      this.loadBookings();
    },
    debouncedSearch: debounce(function () {
      this.pagination.currentPage = 1;
      this.loadBookings();
    }, 1000),
    async loadBookings() {
      this.loading = true;
      const { currentPage, perPage } = this.pagination;
      const res = await this.$apiService.getCall(`booking/all-bookings?page=${currentPage}&limit=${perPage}&search=${this.searchQuery}`);
      const { Code, Data, total, page } = res.apidata;
      if (Code !== "BOK002") {
        this.tableData = Data || [];
        this.pagination.total = total;
        this.pagination.currentPage = page;
        this.noDataMessage = this.tableData.length === 0;
      } else {
        this.$apiService.notify("Failed to load bookings.");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.loadBookings();
  },
  watch: {
    // searchQuery(value) {
    //   let result = this.tableData;
    //   console.log("tabledata",this.tableData)
    //   let demo_result = []
    //   if (value !== "") {

    //     demo_result = result.filter(post => {

    //      // console.log(moment(post.created_at).format('DD-MM-YYYY').toString().toLowerCase())
    //         //return this.tableData.filter((rec) => rec.user_id.phone_number == this.searchQuery)
    //         if(post.user_id.phone_number.toString().toLowerCase().includes(this.searchQuery.toString().toLowerCase())){
    //           return post.user_id.phone_number
    //         }
    //         else if(post.user_id.first_name.toString().toLowerCase().includes(this.searchQuery.toString().toLowerCase())){
    //           return post.user_id.first_name.toString().toLowerCase().includes(this.searchQuery.toString().toLowerCase())
    //         }
    //         else if(post.user_id.last_name.toString().toLowerCase().includes(this.searchQuery.toString().toLowerCase())){
    //           return post.user_id.last_name.toString().toLowerCase().includes(this.searchQuery.toString().toLowerCase())
    //         }
    //         else if(post.event_id.event_name.toLowerCase().includes(this.searchQuery.toLowerCase())){
    //           return post.event_id.event_name
    //         }
    //          else if(post.type.toLowerCase().includes(this.searchQuery.toLowerCase())){
    //           return post.type
    //         }
    //         else if(post.price.toLowerCase().includes(this.searchQuery.toLowerCase())){
    //           return post.price
    //         }
    //       else if(post.booking_status.toLowerCase().includes(this.searchQuery.toLowerCase())){
    //         //console.log('b status');
    //           return post.booking_status.toLowerCase().includes(this.searchQuery.toLowerCase())
    //       }
    //       else if(moment(post.created_at).format('DD-MM-YYYY').toString().toLowerCase().includes(moment(this.searchQuery).format('MM-DD-YYYY').toString().toLowerCase())){
    //         //console.log('created at');
    //           return post.created_at
    //       }
    //       else if(moment(post.canceled_at).format('DD-MM-YYYY').toString().toLowerCase().includes(moment(this.searchQuery).format('MM-DD-YYYY').toString().toLowerCase())){
    //         //console.log('created at');
    //           return post.canceled_at
    //       }
    //     })
    //   }
    //   console.log("result", demo_result)
    //   this.searchedData  = demo_result;
    // },
    searchQuery() {
      // this.pagination.currentPage = 1;
      this.debouncedSearch();
    },
    "pagination.currentPage"() {
      this.loadBookings();
    },
    "pagination.perPage"() {
      this.pagination.currentPage = 1;
      this.loadBookings();
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: all;
}
</style>
